const reasoningBlockPattern = /<(think|analysis)[^>]*>[\s\S]*?<\/\1>/gi
const reasoningTagLinePattern = /^\s*<\/?(think|analysis)[^>]*>\s*$/gim
const reasoningTitleLinePattern = /^\s*(思考过程|推理过程|分析过程)\s*[:：].*$/gim
const trailingSlashLinePattern = /[ \t\u3000]*[/／]+[ \t\u3000]*$/gm
const multilineGapPattern = /\n{3,}/g
const emptyReplyFallback = '抱歉哟,粥皮小兵没有听懂,请重新提问'

export function sanitizeCustomerServiceContent(content) {
  const text = typeof content === 'string' ? content : String(content ?? '')
  if (!text.trim()) {
    return ''
  }

  let sanitized = text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim()

  sanitized = sanitized
    .replace(reasoningBlockPattern, '')
    .replace(reasoningTagLinePattern, '')
    .replace(reasoningTitleLinePattern, '')
    .replace(trailingSlashLinePattern, '')
    .replace(multilineGapPattern, '\n\n')
    .trim()

  if (!sanitized && /<\s*(think|analysis)[^>]*>/i.test(text)) {
    return emptyReplyFallback
  }

  return sanitized
}

export function normalizeCustomerServiceMessage(message = {}) {
  if (!message) {
    return null
  }

  const sanitizedContent = sanitizeCustomerServiceContent(message?.content)
  const shouldUseFallback = message?.role && message.role !== 'user' && !sanitizedContent

  return {
    ...message,
    content: shouldUseFallback ? emptyReplyFallback : sanitizedContent,
  }
}

export function normalizeCustomerServiceConversation(conversation = {}) {
  if (!conversation) {
    return null
  }

  return {
    ...conversation,
    lastAnswerPreview: sanitizeCustomerServiceContent(conversation?.lastAnswerPreview),
  }
}
